/* eslint-disable no-unused-vars */
/* eslint-disable indent */
/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Card, Row, Col, message, Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import moment from "moment";
import {
    TableComponent
} from "../../../CommonComponents";
import "../../styles.scss";
import Heading from "../../../../../components/Heading";
import { ReportsService } from "../../../../../services/api/reports";
import { downloadNotInscannedByCpClickable } from "../../../../../utils/downloadUtils";
import { useRequestCancellation } from "../../../../../hooks/useRequestCancellation";
import { useNavigate, useLocation } from "react-router-dom";
import { showErrorMessage } from "../../../../../utils";

const NotInscannedByCpClickableReport = () => {
    // Global request cancellation hook
    const { createNewRequest, isLatestRequest } = useRequestCancellation();

    const [loading, setLoading] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`
    });
    const [reportData, setReportData] = useState([]);

    const [hubUser, setHubUser] = useState();

    const navigate = useNavigate();
    const location = useLocation();

    // Set user role
    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("userinfo"));
        setHubUser(user?.roles?.[0]);
    }, []);

    // Fetch report data
    useEffect(() => {
        if (!hubUser) return;
        if (!location.state) return;
        const { date, fromDate } = location.state;
        const dateValue = date || fromDate;
        if (!dateValue) return;
        fetchReport();
        // eslint-disable-next-line
    }, [hubUser, location.state, pagination.current, pagination.pageSize]);

    const fetchReport = async () => {
        // 🔥 Create new request for cancellation support
        const requestId = createNewRequest();

        setLoading(true);
        let shouldUpdateState = true;

        try {
            // Get form parameters from location.state
            const formParams = location.state || {};
            const { date, fromDate, fromHubId, cpId, hubId, deliveryCpId, toCpId } = formParams;
            // Use date if available, otherwise fall back to fromDate
            const dateValue = date || fromDate;
            if (!dateValue) {
                setLoading(false);
                return;
            }

            setReportData([]);

            const params = {
                date: moment(dateValue).format("YYYY-MM-DD"),
                fromHubId: fromHubId || hubId,
                cpId: cpId || deliveryCpId || toCpId,
                page: (pagination.current - 1),
                size: pagination.pageSize
            };

            const { data, total } = await ReportsService.getNotInscannedByCpClickable(params);

            // 🔥 Check if this is still the latest request
            if (!isLatestRequest(requestId.requestId)) {
                shouldUpdateState = false;
            } else {
                setReportData(data || []);
                setPagination(prev => ({
                    ...prev,
                    total: total || 0,
                }));
            }
        } catch (error) {
            console.error("API error:", error);
            // 🔥 Check if this is still the latest request
            if (!isLatestRequest(requestId.requestId)) {
                shouldUpdateState = false;
            } else {
                showErrorMessage("Failed to fetch not inscanned by CP report data");
                setReportData([]);
                setPagination(prev => ({
                    ...prev,
                    total: 0
                }));
            }
        } finally {
            // 🔥 Check if this is still the latest request
            if (isLatestRequest(requestId.requestId)) {
                setLoading(false);
            }
        }
    };

    const handleTableChange = (newPagination) => {
        setPagination(prev => ({
            ...prev,
            current: newPagination.current,
            pageSize: newPagination.pageSize
        }));
    };

    const handleDownload = async () => {
        // Get form parameters from location.state
        const formParams = location.state || {};
        const { date, fromDate, fromHubId, cpId, hubId, deliveryCpId, toCpId } = formParams;
        // Use date if available, otherwise fall back to fromDate
        const dateValue = date || fromDate;

        if (!dateValue) {
            showErrorMessage("Form parameters are missing for download");
            return;
        }

        setDownloadLoading(true);
        try {
            const downloadParams = {
                date: moment(dateValue).format("YYYY-MM-DD"),
                fromHubId: fromHubId || hubId,
                cpId: cpId || deliveryCpId || toCpId
            };

            await downloadNotInscannedByCpClickable(downloadParams);

            message.success("Report downloaded successfully");
        } catch (error) {
            console.error("Download error:", error);
            message.error("Failed to download report");
        } finally {
            setDownloadLoading(false);
        }
    };

    const handleBack = () => {
        navigate("/outscan-cpinscan");
    };

    const columns = [
        {
            title: "AWB Number",
            dataIndex: "awbNumber",
            key: "awbNumber",
            sorter: true,
            align: "center",
            width: 150,
            render: (text, record) => (
                <span
                    style={{ color: "#1890ff", cursor: "pointer", textDecoration: "underline" }}
                    onClick={() => {
                        const url = `/shipment-tracker?awb=${text}`;
                        window.open(url, "_blank");
                    }}
                >
                    {text}
                </span>
            )
        },
        {
            title: "Date",
            dataIndex: "date",
            key: "date",
            sorter: true,
            align: "center",
            width: 120,
            render: (text) => text ? moment(text).format("YYYY-MM-DD") : "-"
        },
        {
            title: "From Hub",
            dataIndex: "fromHub",
            key: "fromHub",
            sorter: true,
            align: "center",
            width: 150
        },
        {
            title: "CP Name",
            dataIndex: "cpName",
            key: "cpName",
            sorter: true,
            align: "center",
            width: 150
        },
        {
            title: "Weight (Kg)",
            dataIndex: "weight",
            key: "weight",
            sorter: true,
            align: "center",
            width: 120,
            render: (text) => text || "-"
        }
    ];

    return (
        <div className="report-container">
            <div style={{ backgroundColor: "white", padding: "8px 16px", borderRadius: "8px" }}>
                <Heading
                    title="Not Inscanned By CP Report"
                    navigateTo="/outscan-cpinscan"
                    showBackButton={true}
                    onBackClick={handleBack}
                >
                    <Button
                        type="primary"
                        icon={<DownloadOutlined />}
                        loading={downloadLoading}
                        onClick={handleDownload}
                    >
                        Download Report
                    </Button>
                </Heading>
            </div>
            <TableComponent
                columns={columns}
                dataSource={reportData}
                loading={loading}
                pagination={pagination}
                onChange={handleTableChange}
                rowKey={(record, index) => record.awbNumber || record.id || record.awb || index}
                style={{ marginTop: 32 }}
            />
        </div>
    );
};

export default NotInscannedByCpClickableReport;
